// import axios from "axios";
// export default axios.create({
//   baseURL: "http://localhost:5000/api"
// });


import axios from "axios";
export default axios.create({
  baseURL: "/api"
});